export default "__VITE_ASSET__SJezfbrO__"